/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Table_Assigned_To_HeaderInputs */



/**
* | output |
* | --- |
* | "Assigned To" |
*
* @param {Explorer_Table_Assigned_To_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_assigned_to_header = /** @type {((inputs?: Explorer_Table_Assigned_To_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Assigned_To_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Assigne a")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zugewiesen an")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assegnato a")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Назначен в")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asignado a")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分配给")
	if (locale === "ja") return /** @type {LocalizedString} */ ("割り当て先")
	if (locale === "hi") return /** @type {LocalizedString} */ ("को सौंपना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Designado para")
	return /** @type {LocalizedString} */ ("Assigned To")
});